import { createAsyncThunk } from '@reduxjs/toolkit'
import { showToast } from '../../../../shared/lib/showToast/showToast'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { fetchApps } from '../../../../pages/AppsPage'
import { selectNewApp } from '../selectors/selectNewApp'
import { AppSecretKeySchema } from '../../../../widgets/ApplicationSecretKey'
import {
	mapRightsNoPermissionToNull
} from '../../../../shared/lib/mappers/mapRightsNoPermissionToNull'

export const addNewApplication = createAsyncThunk<AppSecretKeySchema, void, ThunkConfig<string>>(
	'newApplication/addNewApplication',
	async (_, thunkAPI) => {
		const {
			dispatch,
			getState,
			extra: { api },
			rejectWithValue
		} = thunkAPI

		const newApp = selectNewApp(getState())
		const expirationDate = newApp.expirationDate?.toISOString()
		const rights = mapRightsNoPermissionToNull(newApp.rights)
		const newAppDTO = { ...newApp, expirationDate, rights }

		try {
			const { data } = await api.post('/applications', newAppDTO)

			showToast({
				type: 'success',
				toastId: 'newApplication',
				message: 'New application created'
			})

			dispatch(fetchApps())

			return data
		} catch (e) {
			console.log(e)
			appHandleError(e, 'newApplicationCreated', 'Failed to add a new application')
			return rejectWithValue('Error occurred while creating a new application')
		}
	}
)
